import { getExperimentPropertiesForEventPayload } from './../lib/platform/getExperimentPropertiesForEventPayload';

//
// Segment analytics link tracking that includes experiment data.
//
// https://segment.com/docs/libraries/analytics.js/
//
export default function trackLink (element, event, params={}) {
    params = { url: window.location.href, ...params };

      params = {
          ...getExperimentPropertiesForEventPayload(),
          ...params,
      };


    if (__DEV__) {
        element.addEventListener('click', () => {
            console.info('Track link: "%s": %o', event, params); // eslint-disable-line no-console
        });
    }

    if (window.analytics) {
        window.analytics.trackLink(element, event, params);
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/platform/trackLink.js